import { render, staticRenderFns } from "./PointLogComponent.vue?vue&type=template&id=0e071bb5&scoped=true"
import script from "./PointLogComponent.vue?vue&type=script&lang=js"
export * from "./PointLogComponent.vue?vue&type=script&lang=js"
import style0 from "./PointLogComponent.vue?vue&type=style&index=0&id=0e071bb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e071bb5",
  null
  
)

export default component.exports